import React from 'react';
import { AnimatedFooter } from './ui/AnimatedFooter';
export function Footer() {
  return <AnimatedFooter leftLinks={[{
    href: '/terminos',
    label: 'Términos y condiciones'
  }, {
    href: '/privacidad',
    label: 'Política de privacidad'
  }]} rightLinks={[{
    href: '/',
    label: 'Inicio'
  }, {
    href: '/servicios',
    label: 'Servicios'
  }, {
    href: '/proceso',
    label: 'Proceso'
  }, {
    href: '/resultados',
    label: 'Enfoque'
  }, {
    href: '/faq',
    label: 'FAQ'
  }, {
    href: '/contacto',
    label: 'Contacto'
  }]} copyrightText={`© ${new Date().getFullYear()} Growthly Corporation Systems. Todos los derechos reservados.`} barCount={23} data-id="element-28" data-mp="3gfsmebmgesmg" />;
}